"use client";
import React, { createContext, useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

export const NavigationContext = createContext({});

export const NavigationProvider = ({ children, initialNavItems = [] }) => {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);
  const [navItems, setNavItems] = useState(initialNavItems);
  const [currentNavId, setCurrentNavId] = useState(initialNavItems[0]?.id || '');

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const value = {
    navItems,
    open,
    setOpen,
    currentNavId,
    setCurrentNavId,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};
